var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.749 4.006a.628.628 0 0 1-.071-.043 15.629 15.629 0 0 0-2.457-1.057l-.386-.129a15.981 15.981 0 0 0-12.593 29.21c.029.014.05.036.079.05a15.628 15.628 0 0 0 2.457 1.057l.386.129A15.983 15.983 0 0 0 25.749 4.006Zm-7.75 26.166a11.562 11.562 0 0 1-1.943-.171 12.154 12.154 0 0 1-2.036-.521c-.136-.043-.271-.086-.4-.136a11.6 11.6 0 0 1-1.357-.614 12.1 12.1 0 0 1-4.1-17.837l16.945 16.943A12.1 12.1 0 0 1 18 30.172Zm9.843-5.072L10.9 8.157A12.087 12.087 0 0 1 18 5.828a11.628 11.628 0 0 1 1.943.171 12.154 12.154 0 0 1 2.036.521c.129.043.264.086.4.136a11.571 11.571 0 0 1 1.286.579A12.084 12.084 0 0 1 27.844 25.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.0832d6ca0fb356dc8b2cbae362a46c95.svg";
export { ForwardRef as ReactComponent };